module.exports = __webpack_public_path__ + "img/oldPeople.97124151.png";